import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ConnectCardReaderPageRoutingModule } from './connect-card-reader-routing.module';

import { ConnectCardReaderPage } from './connect-card-reader.page';

import { SalonMonsterLoadMaskModule } from '../../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../../components/smr-tap-retry/smr-tap-retry.module';
import { SalonMonsterCheckMarkLoaderModule } from '../../../components/smr-checkmark-loader/smr-checkmark-loader.module';
import { SalonMonsterSmallCheckMarkLoaderModule } from "../../../components/smr-small-checkmark-loader/smr-small-checkmark-loader.module";
import { RegisterCardReaderComponentModule } from './register-card-reader/register-card-reader.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ConnectCardReaderPageRoutingModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    SalonMonsterCheckMarkLoaderModule,
    SalonMonsterSmallCheckMarkLoaderModule,
    RegisterCardReaderComponentModule
  ],
  declarations: [ConnectCardReaderPage]
})
export class ConnectCardReaderPageModule {}
